export default __webpack_public_path__ + "static/media/logo.5d4b167b.png";